import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MessageErrorResolver} from "../../utilities/message-error-resolver";
import {catchError, EMPTY, map, Observable, tap} from "rxjs";
import {IPage} from "../../models/pagination/page";
import {IFederationDto} from "../../models/federation-dto";
import {ResponseDto, ResponseWithErrorDto} from "../../models/exceptions/response-dto";
import {ICountryDto} from "../../models/country-dto";
import {IStateDto} from "../../models/state-dto";
import {LoadingService} from "./loading.service";

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private url: string = environment.apiUrl + "/v1/paises";

  constructor(private httpClient: HttpClient,
              private messageErrorResolver: MessageErrorResolver,
              private loadingService: LoadingService) {
  }

  public getAllCountries(page?: number, size?: number,paiTxDescricao?:string): Observable<IPage<ICountryDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    if(paiTxDescricao) params = params.set("paiTxDescricao",paiTxDescricao)
    
    return this.httpClient.get<ResponseDto<IPage<ICountryDto>>>(this.url, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public getAllStatesByCountryId(paiNrId: number, page?: number, size?: number): Observable<IPage<IStateDto>> {
    this.loadingService.activate()
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    return this.httpClient.get<ResponseDto<IPage<IStateDto>>>(this.url + `/${paiNrId}/estados`, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }

  public findCountryById(paiNrId:number):Observable<ICountryDto>{
      return this.httpClient.get<ResponseDto<ICountryDto>>(this.url + `/${paiNrId}`,)
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        }),
        tap(() => this.loadingService.deactivate())
      );
  }
}
